import React, { useEffect, useRef, useState } from "react";

// MetisMenu
import MetisMenu from "metismenujs";
import { Link, useLocation } from "react-router-dom";

import logoLightPng from "../../assets/images/mypet.svg";
import { userRols } from "../../helpers/userRols";

const SidebarContent = ({ userRole }) => {
  const isInitialMount = useRef(true);
  const location = useLocation();
  const [role] = useState(userRole);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      initMenu();
      activeNavigationLinks();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `activeNavigationLinks` is recreated every render; the `isInitialMount` ref limits the body to the first run after mount, so depending on it only adds no-op effect runs on every render.
  }, [location, userRole]);

  const initMenu = () => {
    new MetisMenu(document.getElementById("side-menu"));
  };

  const activeNavigationLinks = () => {
    if (window.location.href !== `${window.location.origin}/login`) {
      const paths = location.pathname.split("/").filter(Boolean);
      const hrefs = [...document.querySelectorAll("a.waves-effect")];
      if (hrefs.find((q) => q.href === window.location.href)) {
        if (paths.length > 1) {
          const indexCurrentPath = hrefs.findIndex(
            (q) => q.href === window.location.href,
          );
          if (indexCurrentPath > 1 && indexCurrentPath < 5) {
            openNavigationSideMenu(hrefs, 1, indexCurrentPath);
          } else if (indexCurrentPath > 5 && indexCurrentPath < 8) {
            openNavigationSideMenu(hrefs, 5, indexCurrentPath);
          }
        } else {
          openNavigationSideMenu(hrefs, 0, [1, 5]);
        }
        hrefs.filter((q) => q.href === window.location.href)[0].className +=
          " mm-active";
      }
    }
  };

  const openNavigationSideMenu = (hrefs, indexOpenLink, indexCurrentPath) => {
    if ([userRols.admin, userRols.superAdmin].includes(role)) {
      if (indexOpenLink > 0) {
        hrefs[indexOpenLink].ariaExpanded = true;
        hrefs[indexOpenLink].parentElement.className = " mm-active";
        hrefs[indexCurrentPath].parentElement.parentElement.className +=
          " mm-show";
      } else {
        indexCurrentPath.forEach((ind) => {
          hrefs[ind].ariaExpanded = false;
          hrefs[ind].parentElement.className = "";
          const currentHref = [...hrefs[ind].parentElement.children][1];
          if (currentHref) {
            currentHref.className = "mm-collapse";
          }
        });
      }
    }
  };

  const activateParentDropdown = (item) => {
    const target = document.getElementsByClassName("mm-active");
    if ([...target].length) {
      [...target].forEach((tr) => {
        tr.className = tr.className.replace(/ mm-active/g, "");
      });
    }

    item.target.className += " mm-active";
  };

  return (
    <React.Fragment>
      <div className="navbar-brand-box">
        <Link
          to="/"
          className="logo logo-light"
          onClick={() => activateParentDropdown("")}
        >
          <span className="logo-lg">
            <img src={logoLightPng} alt="" height="80" />
          </span>
        </Link>
      </div>

      <div id="sidebar-menu">
        <ul className="metismenu list-unstyled" id="side-menu">
          <li className="menu-title">Начало</li>
          <li>
            <Link
              to="/dashboard"
              className="waves-effect"
              onClick={(e) => {
                activateParentDropdown(e, true);
              }}
            >
              <span>Табло</span>
            </Link>
          </li>

          <li>
            <Link to="#profesional" className="waves-effect">
              <span>Специалисти >></span>
            </Link>

            <ul>
              <li>
                <Link
                  to="/professional/vets"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e);
                  }}
                >
                  <span>Ветеринарни лекари</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/professional/clinics"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e);
                  }}
                >
                  <span>Ветеринарни клиники</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/professional/groomers"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e);
                  }}
                >
                  <span>Грумъри</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/professional/hotels"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e);
                  }}
                >
                  <span>Хотели</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/professional/pet-sitters"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e);
                  }}
                >
                  <span>Гледачи</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/professional/pet-walkers"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e);
                  }}
                >
                  <span>Разхождачи на кучета</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/professional/all"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e);
                  }}
                >
                  <span>Всички специалисти</span>
                </Link>
              </li>
              {[userRols.admin, userRols.superAdmin].includes(role) && (
                <li>
                  <Link
                    to="/professional/services"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Услуги</span>
                  </Link>
                </li>
              )}
            </ul>
          </li>

          {[userRols.admin, userRols.superAdmin].includes(role) && (
            <li>
              <Link to="#pet-owners" className="waves-effect">
                <span>Стопани >></span>
              </Link>

              <ul>
                <li>
                  <Link
                    to="/pet-owners/parents"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Стопани</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/pet-owners/pets"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Домашни любимци</span>
                  </Link>
                </li>
              </ul>
            </li>
          )}
          {[userRols.admin, userRols.superAdmin].includes(role) && (
            <li>
              <Link to="#pet-owners" className="waves-effect">
                <span>Приюти >></span>
              </Link>

              <ul>
                <li>
                  <Link
                    to="/shelters"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Приюти</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/shelters/pets"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Домашни любимци</span>
                  </Link>
                </li>
              </ul>
            </li>
          )}

          {[userRols.admin, userRols.superAdmin].includes(role) && (
            <li>
              <Link to="#bookings" className="waves-effect">
                <span>Резервации >></span>
              </Link>
              <ul>
                <li>
                  <Link
                    to="/bookings/"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Резервации</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/bookings/pending"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Чакащи резервации</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/bookings/subscription"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Абонаментни резервации</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/bookings/coupons"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Купони / Ваучери</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/bookings/initiated-bookings"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Започнати резервации</span>
                  </Link>
                </li>
              </ul>
            </li>
          )}

          {[userRols.admin, userRols.superAdmin].includes(role) && (
            <li>
              <Link to="#accounting" className="waves-effect">
                <span>Счетоводство >></span>
              </Link>
              <ul>
                <li>
                  <Link
                    to="/accounting/report"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Отчет за транзакции</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/accounting/invoicing"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>За фактуриране</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/accounting/profpayments"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Отбелязване на плащания</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/accounting/invoices"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Издадени фактури</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/accounting/accountants"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Експорт на НАП файл</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/accounting/received"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Разписки</span>
                  </Link>
                </li>
              </ul>
            </li>
          )}
          {[userRols.admin, userRols.superAdmin].includes(role) && (
            <li>
              <Link to="#financial-settings" className="waves-effect">
                <span>Финансови настройки >></span>
              </Link>
              <ul>
                <li>
                  <Link
                    to="/financial-settings/subscriptions"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Абонаменти</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/financial-settings/transaction-fees"
                    className="waves-effect"
                    onClick={(e) => {
                      activateParentDropdown(e);
                    }}
                  >
                    <span>Такси за транзакции</span>
                  </Link>
                </li>
              </ul>
            </li>
          )}

          {[userRols.admin, userRols.superAdmin].includes(role) && (
            <li>
              <Link
                to="/blog"
                className="waves-effect"
                onClick={(e) => {
                  activateParentDropdown(e, true);
                }}
              >
                <span>Статии</span>
              </Link>
            </li>
          )}

          {[userRols.admin, userRols.superAdmin].includes(role) && (
            <li>
              <Link
                to="/admins"
                className="waves-effect"
                onClick={(e) => {
                  activateParentDropdown(e, true);
                }}
              >
                <span>Управление на администратори</span>
              </Link>
            </li>
          )}
          {[userRols.admin, userRols.superAdmin].includes(role) && (
            <>
              <li>
                <Link
                  to="/marketing-pages"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e, true);
                  }}
                >
                  <span>Маркетингови страници</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/promo-banners"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e, true);
                  }}
                >
                  <span>Промо лента</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/testimonials"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e, true);
                  }}
                >
                  <span>Отзиви</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/promotions"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e, true);
                  }}
                >
                  <span>Промоции</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/comments"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e, true);
                  }}
                >
                  <span>Коментари</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e, true);
                  }}
                >
                  <span>Често задавани въпроси</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/redirects"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e, true);
                  }}
                >
                  <span>Пренасочвания</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/translation-glossary"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e, true);
                  }}
                >
                  <span>Речник за преводи</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/site-updates"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e, true);
                  }}
                >
                  <span>Обновяване на сайта</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/subscribers"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e, true);
                  }}
                >
                  <span>Абонати</span>
                </Link>
              </li>
            </>
          )}
          {[userRols.admin, userRols.superAdmin].includes(role) && (
            <li>
              {role === userRols.superAdmin && (
                <Link
                  to="/logs"
                  className="waves-effect"
                  onClick={(e) => {
                    activateParentDropdown(e, true);
                  }}
                >
                  <span>Одитен журнал</span>
                </Link>
              )}
            </li>
          )}
          <li>
            <Link
              to="/logout"
              className="waves-effect"
              onClick={(e) => {
                activateParentDropdown(e, true);
              }}
            >
              <span>Изход</span>
            </Link>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};

export default SidebarContent;
